// Mock data for SwapWise HK

// Current logged-in user
export const mockUser = {
  id: 'user123',
  username: 'JamesChan',
  email: 'james.chan@example.com',
  avatar: 'https://randomuser.me/api/portraits/men/1.jpg',
  joinDate: '2023-01-15'
};

// Other users in the system
export const mockUsers = [
  { 
    id: 'seller456', 
    username: 'TechTrader', 
    avatar: 'https://randomuser.me/api/portraits/women/2.jpg',
    rating: 4.8,
    joinDate: '2022-05-20'
  },
  { 
    id: 'buyer789', 
    username: 'ElectronicsExpert',
    avatar: 'https://randomuser.me/api/portraits/men/3.jpg',
    rating: 4.6,
    joinDate: '2022-08-12'
  },
  { 
    id: 'techguru101', 
    username: 'TechGuru',
    avatar: 'https://randomuser.me/api/portraits/women/4.jpg',
    rating: 4.9,
    joinDate: '2021-11-05'
  },
  { 
    id: 'gadgetpro', 
    username: 'GadgetPro',
    avatar: 'https://randomuser.me/api/portraits/men/5.jpg',
    rating: 4.7,
    joinDate: '2022-02-28'
  },
  { 
    id: 'tech_enthusiast', 
    username: 'TechEnthusiast',
    avatar: 'https://randomuser.me/api/portraits/women/6.jpg',
    rating: 4.5,
    joinDate: '2022-10-15'
  }
];

// Product listings
export const mockListings = [
  {
    id: 'list001',
    title: 'iPhone 13 Pro - Excellent Condition',
    description: 'iPhone 13 Pro 256GB in Pacific Blue. Purchased last year, in excellent condition with original box and accessories. Battery health at 92%.',
    price: 5800,
    condition: 'Fully Working',
    category: 'Mobile Phones',
    imageUrl: '/images/listings/iphone-13-pro.webp',
    sellerId: 'seller456',
    sellerUsername: 'TechTrader',
    isAuction: false,
    location: 'Kowloon',
    postedDate: '2025-03-15',
    views: 45,
    similarItems: ['list004', 'list007', 'list012']
  },
  {
    id: 'list002',
    title: 'MacBook Pro M1 - 2021 Model',
    description: 'MacBook Pro with M1 chip, 16GB RAM, 512GB SSD. Space Grey. Very light usage, perfect working condition.',
    price: 9500,
    condition: 'Fully Working',
    category: 'Laptops',
    imageUrl: '/images/listings/macbook-pro-m1.webp',
    sellerId: 'techguru101',
    sellerUsername: 'TechGuru',
    isAuction: false,
    location: 'Hong Kong Island',
    postedDate: '2025-03-20',
    views: 78,
    similarItems: ['list008']
  },
  {
    id: 'list003',
    title: 'PlayStation 5 - Auction!',
    description: 'PS5 Digital Edition with extra controller. Used for 6 months, in perfect condition. Selling because I don\'t have enough time to use it.',
    price: 2800,
    condition: 'Fully Working',
    category: 'Gaming Gear',
    imageUrl: '/images/listings/playstation-5.webp',
    sellerId: 'gadgetpro',
    sellerUsername: 'GadgetPro',
    isAuction: true,
    currentBid: 2800,
    endTime: '2025-04-30T15:00:00',
    location: 'New Territories',
    postedDate: '2025-03-18',
    views: 120,
    similarItems: ['list009', 'list014']
  },
  {
    id: 'list004',
    title: 'Samsung Galaxy S22 Ultra - Minor Screen Scratch',
    description: 'Galaxy S22 Ultra 128GB in Phantom Black. Has one minor scratch on screen (see photos), otherwise perfect. Comes with original charger.',
    price: 4200,
    condition: 'Minor Defects',
    category: 'Mobile Phones',
    imageUrl: '/images/listings/samsung-s22-ultra.webp',
    sellerId: 'tech_enthusiast',
    sellerUsername: 'TechEnthusiast',
    isAuction: false,
    location: 'Kowloon',
    postedDate: '2025-03-25',
    views: 32,
    similarItems: ['list001', 'list012']
  },
  {
    id: 'list005',
    title: 'NVIDIA RTX 3080 Graphics Card',
    description: 'NVIDIA RTX 3080 Founders Edition. Used for gaming only, never for mining. Works perfectly.',
    price: 6500,
    condition: 'Fully Working',
    category: 'Components',
    imageUrl: '/images/listings/rtx-3080.webp',
    sellerId: 'seller456',
    sellerUsername: 'TechTrader',
    isAuction: false,
    location: 'All of Hong Kong',
    postedDate: '2025-03-12',
    views: 93,
    similarItems: ['list011', 'list015', 'list017']
  },
  {
    id: 'list006',
    title: 'Sony A7III Camera - Professional Kit',
    description: 'Sony A7III with 24-70mm f/2.8 G Master lens. Includes extra battery, 128GB SD card, and camera bag. Shutter count under 5000.',
    price: 15800,
    condition: 'Fully Working',
    category: 'Cameras',
    imageUrl: '/images/listings/sony-a7iii.webp',
    sellerId: 'techguru101',
    sellerUsername: 'TechGuru',
    isAuction: true,
    currentBid: 15800,
    endTime: '2025-04-25T20:00:00',
    location: 'Hong Kong Island',
    postedDate: '2025-03-10',
    views: 56,
    similarItems: ['list010', 'list016']
  },
  {
    id: 'list007',
    title: 'iPad Pro 12.9" - 2021 Model',
    description: 'iPad Pro 12.9" with M1 chip, 256GB. Includes Apple Pencil 2nd gen and Magic Keyboard. Used for artwork, in perfect condition.',
    price: 7800,
    condition: 'Fully Working',
    category: 'Mobile Phones',
    imageUrl: '/images/listings/ipad-pro.webp',
    sellerId: 'gadgetpro',
    sellerUsername: 'GadgetPro',
    isAuction: false,
    location: 'Kowloon',
    postedDate: '2025-03-22',
    views: 47,
    similarItems: ['list001', 'list002']
  },
  {
    id: 'list008',
    title: 'Dell XPS 15 - For Parts or Repair',
    description: 'Dell XPS 15 (2020 model) with display issues. Powers on but screen flickers. Good for parts or repair project.',
    price: 1800,
    condition: 'For Parts/Repair Only',
    category: 'Laptops',
    imageUrl: '/images/listings/dell-xps-15.webp',
    sellerId: 'tech_enthusiast',
    sellerUsername: 'TechEnthusiast',
    isAuction: false,
    location: 'New Territories',
    postedDate: '2025-03-05',
    views: 28,
    similarItems: ['list002']
  },
  {
    id: 'list009',
    title: 'Nintendo Switch OLED Model',
    description: 'Nintendo Switch OLED in white. Includes 5 games (Mario Kart, Zelda, Animal Crossing, Super Smash Bros, Pokemon). Barely used.',
    price: 2500,
    condition: 'Fully Working',
    category: 'Gaming Gear',
    imageUrl: '/images/listings/nintendo-switch-oled.webp',
    sellerId: 'buyer789',
    sellerUsername: 'ElectronicsExpert',
    isAuction: false,
    location: 'Hong Kong Island',
    postedDate: '2025-03-28',
    views: 65,
    similarItems: ['list003', 'list014']
  },
  {
    id: 'list010',
    title: 'Canon EOS R6 - Full Frame Mirrorless',
    description: 'Canon EOS R6 with RF 24-105mm f/4L lens. Perfect for photography and video. Used for only 6 months.',
    price: 18500,
    condition: 'Fully Working',
    category: 'Cameras',
    imageUrl: '/images/listings/canon-eos-r6.webp',
    sellerId: 'seller456',
    sellerUsername: 'TechTrader',
    isAuction: true,
    currentBid: 18500,
    endTime: '2025-05-02T12:00:00',
    location: 'All of Hong Kong',
    postedDate: '2025-03-17',
    views: 42,
    similarItems: ['list006', 'list016']
  },
  {
    id: 'list011',
    title: 'AMD Ryzen 9 5900X CPU',
    description: 'AMD Ryzen 9 5900X processor. Used for 8 months in a gaming PC. Works perfectly, upgraded to newer generation.',
    price: 3200,
    condition: 'Fully Working',
    category: 'Components',
    imageUrl: '/images/listings/ryzen-5900x.webp',
    sellerId: 'techguru101',
    sellerUsername: 'TechGuru',
    isAuction: false,
    location: 'Kowloon',
    postedDate: '2025-03-19',
    views: 37,
    similarItems: ['list005', 'list015']
  },
  {
    id: 'list012',
    title: 'Xiaomi Mi 11 Ultra - Minor Battery Issue',
    description: 'Xiaomi Mi 11 Ultra 256GB. Phone works great but battery drains faster than normal. Could benefit from a battery replacement.',
    price: 2900,
    condition: 'Minor Defects',
    category: 'Mobile Phones',
    imageUrl: '/images/listings/xiaomi-mi-11-ultra.webp',
    sellerId: 'gadgetpro',
    sellerUsername: 'GadgetPro',
    isAuction: false,
    location: 'New Territories',
    postedDate: '2025-03-23',
    views: 29,
    similarItems: ['list001', 'list004']
  },
  {
    id: 'list013',
    title: 'Bose QuietComfort Earbuds II',
    description: 'Bose QuietComfort Earbuds II in black. Incredible noise cancellation. Purchased 3 months ago, selling because I received another pair as a gift.',
    price: 1900,
    condition: 'Fully Working',
    category: 'Audio',
    imageUrl: '/images/listings/bose-quietcomfort.webp',
    sellerId: 'tech_enthusiast',
    sellerUsername: 'TechEnthusiast',
    isAuction: false,
    location: 'Hong Kong Island',
    postedDate: '2025-03-27',
    views: 48,
    similarItems: []
  },
  {
    id: 'list014',
    title: 'Xbox Series X - Auction',
    description: 'Xbox Series X with 2 controllers and 3 games. In perfect condition, all original packaging included.',
    price: 3500,
    condition: 'Fully Working',
    category: 'Gaming Gear',
    imageUrl: '/images/listings/xbox-series-x.webp',
    sellerId: 'buyer789',
    sellerUsername: 'ElectronicsExpert',
    isAuction: true,
    currentBid: 3500,
    endTime: '2025-04-28T18:00:00',
    location: 'Kowloon',
    postedDate: '2025-03-11',
    views: 83,
    similarItems: ['list003', 'list009']
  },
  {
    id: 'list015',
    title: 'Samsung Odyssey G9 49" Gaming Monitor',
    description: '49-inch curved gaming monitor with 240Hz refresh rate. Some light scratches on the back panel (not visible when in use).',
    price: 7200,
    condition: 'Minor Defects',
    category: 'Components',
    imageUrl: '/images/listings/samsung-odyssey-g9.webp',
    sellerId: 'seller456',
    sellerUsername: 'TechTrader',
    isAuction: false,
    location: 'All of Hong Kong',
    postedDate: '2025-03-21',
    views: 61,
    similarItems: ['list005', 'list017']
  },
  {
    id: 'list016',
    title: 'GoPro HERO10 Black',
    description: 'GoPro HERO10 Black with accessories kit including extra batteries, memory cards, and mounts. Perfect for action photography.',
    price: 2800,
    condition: 'Fully Working',
    category: 'Cameras',
    imageUrl: '/images/listings/gopro-hero10.webp',
    sellerId: 'techguru101',
    sellerUsername: 'TechGuru',
    isAuction: false,
    location: 'New Territories',
    postedDate: '2025-03-26',
    views: 39,
    similarItems: ['list006', 'list010']
  },
  {
    id: 'list017',
    title: 'Mechanical Keyboard - Custom Built',
    description: 'Custom mechanical keyboard with Gateron Brown switches, PBT keycaps, and aluminum case. Perfect typing experience for programmers.',
    price: 1200,
    condition: 'Fully Working',
    category: 'Components',
    imageUrl: '/images/listings/mechanical-keyboard.webp',
    sellerId: 'gadgetpro',
    sellerUsername: 'GadgetPro',
    isAuction: false,
    location: 'Hong Kong Island',
    postedDate: '2025-03-24',
    views: 52,
    similarItems: ['list005', 'list015']
  },
  {
    id: 'rtx4070',
    title: 'NVIDIA RTX 4070 Graphics Card - Like New',
    description: 'NVIDIA RTX 4070 12GB GDDR6X. Purchased 3 months ago, barely used. Perfect for gaming, content creation and AI workloads. Ray tracing and DLSS 3.0 capable. Comes in original packaging with all accessories.',
    price: 5999,
    condition: 'Fully Working',
    category: 'Components',
    imageUrl: '/images/listings/rtx-4070.webp',
    sellerId: 'techguru101',
    sellerUsername: 'TechGuru',
    isAuction: false,
    location: 'Hong Kong Island',
    postedDate: '2025-03-05',
    views: 118,
    similarItems: ['list005', 'list011', 'list015']
  },
  {
    id: 'list018',
    title: 'Custom Gaming Desktop PC - RTX 4080, i9-13900K',
    description: 'High-end custom-built gaming PC featuring Intel i9-13900K CPU, NVIDIA RTX 4080 16GB, 64GB DDR5 RAM, 2TB NVMe SSD + 4TB HDD, NZXT H7 Flow case with RGB fans and liquid cooling. Built 4 months ago, selling due to relocation. All original boxes for components included.',
    price: 15000,
    condition: 'Fully Working',
    category: 'Computers',
    imageUrl: '/images/listings/custom-pc-rtx4080.webp',
    sellerId: 'techguru101',
    sellerUsername: 'TechGuru',
    isAuction: true,
    currentBid: 15000,
    endTime: '2025-05-10T18:00:00',
    location: 'Hong Kong Island',
    postedDate: '2025-04-01',
    views: 142,
    similarItems: ['list005', 'list011', 'rtx4070']
  }
];

// Want to Buy requests
export const mockWtbRequests = [
  {
    id: 'wtb001',
    userId: 'user123',
    username: 'JamesChan',
    title: 'Looking for iPhone 12 or newer',
    description: 'Searching for an iPhone 12 or newer model in good condition. Prefer 128GB+ storage. Budget between 3000-4500 HKD depending on model and condition.',
    desiredCondition: 'Fully Working',
    priceRange: '3000-4500 HKD',
    category: 'Mobile Phones',
    postedDate: '2025-03-22'
  },
  {
    id: 'wtb002',
    userId: 'buyer789',
    username: 'ElectronicsExpert',
    title: 'Wanted: Gaming Laptop',
    description: 'Looking for a gaming laptop with RTX 3060 or better GPU. At least 16GB RAM and 512GB SSD. Must be in good working condition with no major issues.',
    desiredCondition: 'Fully Working',
    priceRange: '6000-9000 HKD',
    category: 'Laptops',
    postedDate: '2025-03-18'
  },
  {
    id: 'wtb003',
    userId: 'techguru101',
    username: 'TechGuru',
    title: 'Searching for iPad Pro',
    description: 'Want to buy iPad Pro (11" or 12.9"), 2020 model or newer. Interested in any storage capacity. Apple Pencil would be a plus.',
    desiredCondition: 'Fully Working or Minor Defects',
    priceRange: '4000-7000 HKD',
    category: 'Mobile Phones',
    postedDate: '2025-03-25'
  },
  {
    id: 'wtb004',
    userId: 'gadgetpro',
    username: 'GadgetPro',
    title: 'Looking for Sony or Fujifilm Mirrorless Camera',
    description: 'Interested in Sony A7 series or Fujifilm X-T series cameras. Body only is fine, but would consider with lens. Budget depends on specific model and condition.',
    desiredCondition: 'Fully Working',
    priceRange: '8000-15000 HKD',
    category: 'Cameras',
    postedDate: '2025-03-15'
  },
  {
    id: 'wtb005',
    userId: 'tech_enthusiast',
    username: 'TechEnthusiast',
    title: 'Wanted: Graphics Card for Gaming PC',
    description: 'Looking for RTX 3070, 3080, or equivalent AMD card for my gaming PC build. Must be in working condition with no mining history.',
    desiredCondition: 'Fully Working',
    priceRange: '5000-8000 HKD',
    category: 'Components',
    postedDate: '2025-03-20'
  },
  {
    id: 'wtb006',
    userId: 'user123',
    username: 'JamesChan',
    title: 'Searching for Nintendo Switch Games',
    description: 'Looking to buy Nintendo Switch games, particularly Zelda, Mario, or Pokémon titles. Physical copies only.',
    desiredCondition: 'Fully Working',
    priceRange: '200-400 HKD per game',
    category: 'Gaming Gear',
    postedDate: '2025-03-27'
  }
];

// Repair shops
export const mockRepairShops = [
  {
    id: 'repair001',
    name: 'TechFix HK',
    address: '123 Nathan Road, Mong Kok, Kowloon',
    specialization: 'Smartphones & Tablets',
    contactNumber: '+852 1234 5678',
    promoImage: '/images/repair-shops/techfix-hk.webp',
    shortBlurb: 'Fast and reliable smartphone repair service with 90-day warranty. Specializing in screen replacements and water damage recovery.',
    rating: 4.7,
    reviewCount: 245,
    openingHours: 'Mon-Sat: 10:00-20:00, Sun: 12:00-18:00'
  },
  {
    id: 'repair002',
    name: 'Laptop Doctors',
    address: '45 Queens Road Central, Central, Hong Kong Island',
    specialization: 'Laptops & Computers',
    contactNumber: '+852 2345 6789',
    promoImage: '/images/repair-shops/laptop-doctors.webp',
    shortBlurb: 'Professional laptop repair services with same-day diagnostics. Data recovery, hardware upgrades, and software optimization.',
    rating: 4.8,
    reviewCount: 189,
    openingHours: 'Mon-Fri: 09:00-19:00, Sat: 10:00-17:00, Sun: Closed'
  },
  {
    id: 'repair003',
    name: 'Camera Clinic',
    address: '78 Sai Yeung Choi Street, Mong Kok, Kowloon',
    specialization: 'Cameras & Photography Equipment',
    contactNumber: '+852 3456 7890',
    promoImage: '/images/repair-shops/camera-clinic.webp',
    shortBlurb: 'Expert camera repair and maintenance by certified technicians. Lens calibration, sensor cleaning, and vintage camera restoration.',
    rating: 4.9,
    reviewCount: 156,
    openingHours: 'Tues-Sat: 11:00-19:00, Sun-Mon: Closed'
  },
  {
    id: 'repair004',
    name: 'GameStation Repairs',
    address: '234 Lockhart Road, Wan Chai, Hong Kong Island',
    specialization: 'Gaming Consoles & Accessories',
    contactNumber: '+852 4567 8901',
    promoImage: '/images/repair-shops/gamestation-repairs.webp',
    shortBlurb: 'Specialized in repairing all major gaming consoles including PlayStation, Xbox, and Nintendo. Controller repairs and mod services available.',
    rating: 4.6,
    reviewCount: 98,
    openingHours: 'Mon-Sun: 12:00-22:00'
  },
  {
    id: 'repair005',
    name: 'AudioTech HK',
    address: '56 Pak Tai Street, To Kwa Wan, Kowloon',
    specialization: 'Audio Equipment & Headphones',
    contactNumber: '+852 5678 9012',
    promoImage: '/images/repair-shops/audiotech-hk.webp',
    shortBlurb: 'Professional audio equipment repair services. Headphones, speakers, amplifiers, and vintage audio equipment restoration.',
    rating: 4.5,
    reviewCount: 122,
    openingHours: 'Wed-Mon: 10:00-18:00, Tues: Closed'
  },
  {
    id: 'repair006',
    name: 'iCare Express',
    address: '789 Castle Peak Road, Tsuen Wan, New Territories',
    specialization: 'Apple Products',
    contactNumber: '+852 6789 0123',
    promoImage: '/images/repair-shops/icare-express.webp',
    shortBlurb: 'Apple device specialists offering premium repair services for iPhones, iPads, MacBooks, and more. Genuine parts used.',
    rating: 4.8,
    reviewCount: 207,
    openingHours: 'Mon-Sun: 11:00-20:00'
  }
];

// Product categories
export const mockCategories = [
  { id: 'cat1', name: 'Mobile Phones & Gadgets', icon: '📱' },
  { id: 'cat2', name: 'Computers & Laptops', icon: '💻' },
  { id: 'cat3', name: 'Gaming Gear', icon: '🎮' },
  { id: 'cat4', name: 'Components', icon: '⚙️' },
  { id: 'cat5', name: 'Cameras', icon: '📷' },
  { id: 'cat6', name: 'Audio', icon: '🎧' }
];

// Ad banners
export const mockAdBanners = [
  {
    id: 'ad001',
    imageUrl: '/images/banners/xiaomi.webp',
    altText: 'Xiaomi latest smartphones and gadgets',
    link: '#',
    position: 'home-top'
  },
  {
    id: 'ad002',
    imageUrl: '/images/banners/samsung.webp',
    altText: 'Samsung premium devices',
    link: '#',
    position: 'browse-sidebar'
  },
  {
    id: 'ad003',
    imageUrl: '/images/banners/asus.webp',
    altText: 'ASUS ROG gaming laptops and accessories',
    link: '#',
    position: 'repair-top'
  },
  {
    id: 'ad004',
    imageUrl: '/images/banners/gigabyte.webp',
    altText: 'GIGABYTE premium gaming hardware now available',
    link: '#',
    position: 'browse-bottom'
  }
];

// Chat threads
export const mockChats = [
  {
    chatId: 'chat001',
    otherUserId: 'seller456',
    otherUsername: 'TechTrader',
    listingId: 'list001',
    listingTitle: 'iPhone 13 Pro - Excellent Condition',
    messages: [
      {
        senderId: 'user123',
        text: 'Hi, is this iPhone still available?',
        timestamp: '2025-03-24T14:22:00'
      },
      {
        senderId: 'seller456',
        text: 'Yes it is! Are you interested?',
        timestamp: '2025-03-24T14:25:00'
      },
      {
        senderId: 'user123',
        text: 'What\'s the battery health percentage?',
        timestamp: '2025-03-24T14:26:30'
      },
      {
        senderId: 'seller456',
        text: 'The battery health is at 92%.',
        timestamp: '2025-03-24T14:28:00'
      },
      {
        senderId: 'user123',
        text: 'Great! Would you accept 5500 HKD?',
        timestamp: '2025-03-24T14:30:00'
      },
      {
        senderId: 'seller456',
        text: 'I can do 5600 HKD, including the original charger and box.',
        timestamp: '2025-03-24T14:35:00'
      }
    ],
    rated: false
  },
  {
    chatId: 'chat002',
    otherUserId: 'techguru101',
    otherUsername: 'TechGuru',
    listingId: 'list006',
    listingTitle: 'Sony A7III Camera - Professional Kit',
    messages: [
      {
        senderId: 'user123',
        text: 'Hello, I\'m interested in your Sony camera. Is the price negotiable?',
        timestamp: '2025-03-20T10:15:00'
      },
      {
        senderId: 'techguru101',
        text: 'Hi there! Since it\'s an auction, you can place a bid. The starting price is the minimum.',
        timestamp: '2025-03-20T10:22:00'
      },
      {
        senderId: 'user123',
        text: 'I see. What\'s the shutter count on the camera?',
        timestamp: '2025-03-20T10:25:00'
      },
      {
        senderId: 'techguru101',
        text: 'The shutter count is approximately 4,800. Very low for this model.',
        timestamp: '2025-03-20T10:30:00'
      },
      {
        senderId: 'user123',
        text: 'That\'s good. Does it come with any warranty?',
        timestamp: '2025-03-20T10:32:00'
      },
      {
        senderId: 'techguru101',
        text: 'The manufacturer warranty is valid until November 2025. I can provide the receipt.',
        timestamp: '2025-03-20T10:35:00'
      }
    ],
    rated: false
  },
  {
    chatId: 'chat003',
    otherUserId: 'gadgetpro',
    otherUsername: 'GadgetPro',
    listingId: 'list003',
    listingTitle: 'PlayStation 5 - Auction!',
    messages: [
      {
        senderId: 'gadgetpro',
        text: 'Thanks for your interest in my PS5! Do you have any questions?',
        timestamp: '2025-03-25T16:10:00'
      },
      {
        senderId: 'user123',
        text: 'Yes, does it come with any games?',
        timestamp: '2025-03-25T16:15:00'
      },
      {
        senderId: 'gadgetpro',
        text: 'It doesn\'t come with physical games, but I can include my account which has 3 digital games if you\'d like.',
        timestamp: '2025-03-25T16:18:00'
      },
      {
        senderId: 'user123',
        text: 'That would be great! What games are on the account?',
        timestamp: '2025-03-25T16:20:00'
      },
      {
        senderId: 'gadgetpro',
        text: 'Spider-Man Miles Morales, Demon\'s Souls, and Ratchet & Clank: Rift Apart.',
        timestamp: '2025-03-25T16:22:00'
      }
    ],
    rated: false
  }
];

// Create a named export object
const mockDataExport = {
  mockUser,
  mockUsers,
  mockListings,
  mockWtbRequests,
  mockRepairShops,
  mockCategories,
  mockAdBanners,
  mockChats
};

// Export the named object
export default mockDataExport; 